import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Button } from '@components/main-components/button/Button';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { LOADING_STYLES } from '@components/main-components/skeleton/Skeleton';
import { MediaQuery } from '@context/mediaQuery';
import { useChartCardContext } from './Context';

export function ChartCardButton({
  href,
  label = 'Collect Now',
  onClick,
}: {
  /**
   * Link to the song page
   */
  href: string;
  /**
   * Text to show on button
   */
  label?: string;
  /**
   * Callback for when the button is clicked
   */
  onClick?: () => void;
}) {
  const { isLoadingDetails, isLoadingSummary } = useChartCardContext();
  const { tablet } = MediaQuery.useContainer();
  const isMobile = !tablet;

  return (
    <Container mobile={isMobile} loading={isLoadingDetails || (!isMobile && isLoadingSummary)}>
      <StyledAccessibleLink
        absoluteUri={href}
        fullWidth={isMobile}
        onClick={onClick}
        type="external"
      >
        <Button label={label} variant="primary" fullWidth={isMobile} />
      </StyledAccessibleLink>
    </Container>
  );
}

const Container = styled('div', {
  width: 'fit-content',

  variants: {
    mobile: {
      true: {
        display: 'flex',
        width: '100%',
        background: '$white',
        zIndex: '$above1',
        marginTop: 20,
      },
    },
    loading: {
      true: {
        ...LOADING_STYLES,
        borderRadius: '$medium',

        'div, a': {
          opacity: 0,
        },
      },
    },
  },
});

const StyledAccessibleLink = styled(AccessibleLink, {
  variants: {
    fullWidth: {
      true: {
        width: '100%',
      },
    },
  },
});
